var goaSearch = {};

goaSearch.c = {
  searchDuration: 3, // Default to 3 days
  searchUrl: '/apps/bookthatapp/search',
  apiUrl: 'https://dress-for-a-night.bookthatapp.com/availability',
  apiToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MzMyMSwic2hvcCI6ImRyZXNzLWZvci1hLW5pZ2h0In0.sqJ6QdHsMT6k9lMJwuKp-esnoZl_5Sw5QSjoxxv5LsI',
  dummyProductId: '1234'
}

goaSearch.searchDuration = 3; // Default to 3 days
goaSearch.searchUrl = '/apps/bookthatapp/search';

goaSearch.log = function(msg) {
  console.log('[GOA-log]: ', msg);
}

goaSearch.genTopContent = function() {
  return "<div class='goa-dp-helper-top'><p>Pick a start date 1-2 days before your event</p></div>"
}

goaSearch.genBotContent = function() {
  var botMsg = "*Choose pickup or delivery in the next step";
  var botHelperContent = "" +
    "<div class='goa-dp-helper-bottom'>"+
      "<div class='goa-dp-legend-container'>"+
        "<div class='goa-dp-legend goa-dp-legend-start' style=''>"+
          "<i class='date-sign-wrapper'>"+
            "<i class='date-sign-indicator date-sign-indicator-start'></i>"+
          "</i>"+
          "<p class='goa-dp-legend-message'>"+
            "<strong>PICK UP / DELIVERY </strong>"+
            "<span>by 5pm</span>"+
          "</p>"+
        "</div>"+
        "<div class='goa-dp-legend goa-dp-legend-end'>"+
          "<i class='date-sign-wrapper'>"+
            "<i class='date-sign-indicator date-sign-indicator-end'></i>"+
          "</i>"+
          "<p class='goa-dp-legend-message'>"+
            "<strong>DROP OFF / POST BACK </strong>"+
            "<span>today</span>"+
          "</p>"+
        "</div>"+
        "<div class='goa-dp-legend goa-dp-legend-unavailable'>"+
          "<i class='date-sign-wrapper unavailable'>"+
          "</i>"+
          "<p class='goa-dp-legend-message'>"+
            "<span>Date</span>"+
            "<span>is</span>"+
            "<span>unavailable</span>"+
          "</p>"+
        "</div>"+
      "</div>"+
      "<div class='goa-dp-bot-helper-message'>"+
        "<p>" + botMsg + "</p>"+
      "</div>"+
    "</div>";
  return botHelperContent;
}

goaSearch.configDp = function(jqdp) {
  jqdp.prop('autocomplete', 'off');
  jqdp.prop('readonly', true);

  // Fix datepicker not showing on click (http://stackoverflow.com/questions/22411980/readonly-attr-is-disabling-jquery-datepicker)
  jqdp.click(function() {
    jqdp.datepicker('show');
  });

  // Prevent manually entering rubbish
  jqdp.keydown(function (event) {
    event.preventDefault();
  });

  // Removes keyboard popup on iphone
  jqdp.focus(function() {
    jQ(this).blur();
  });

  // Don't allow pasting bad dates
  jqdp.on('paste', function(e) {
    e.preventDefault();
  });
}

goaSearch.dfForQuery = function(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1; // Month from date object is 0-based
  var date = date.getDate();

  // padding
  if (('' + month).length == 1) month = '0' + month;
  if (('' + date).length == 1) date = '0' + date;

  return year + '-' + month + '-' + date;
}

goaSearch.dfForSearchInput = function(date) {
  // 2019-08-12 --> Mon, Aug 12
  var weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  var weekdayStr = weekDays[date.getDay()];
  var monthStr = months[date.getMonth()];
  var date = date.getDate();
  if (('' + date).length == 1) date = '0' + date; // padding
  return weekdayStr + ', ' + monthStr + ' ' + date;
}

var goaSetupSearchForm = function() {
  console.log('goaSetupSearchForm');

  var _this = this;
  var $anchor = $('.search-by-section');

  if ($anchor.length == 0) {
    _this.log('Invalid DOM structure');
    return;
  }

  $dateInput = $('#search-date');

  var dpOptions = {
    showOtherMonths: true,
    minDate: 0,
    dateFormat: 'yy-mm-dd',
    maxDate: '+2y',
    firstDay: 1,
    selectOtherMonths: true,
    onClose: function(dateText, inst) {
      $(inst.input).removeClass('openDatepicker').css('z-index', '0').trigger('blur');
    },
    onSelect: function(date) {
      var selectedDate = new Date(date);
      var next3Days = new Date(selectedDate.getTime() + 3*24*3600*1000);
      if ($anchor.find('#search-duration').val() == '8-days') {
        next3Days = new Date(selectedDate.getTime() + 7*24*3600*1000);
      }
      var dateRangeStr = _this.dfForSearchInput(selectedDate) + ' - ' + _this.dfForSearchInput(next3Days);
      $dateInput.val(dateRangeStr);

      // month is 0-based
      var from = {year: selectedDate.getFullYear(), month: selectedDate.getMonth(), date: selectedDate.getDate()};
      from = JSON.stringify(from);

      var to = {year: next3Days.getFullYear(), month: next3Days.getMonth(), date: next3Days.getDate()};
      to = JSON.stringify(to);

      $dateInput.attr('data-search-from', from);
      $dateInput.attr('data-search-to', to);
    }
  };
  var jqdp = $dateInput.datepicker(dpOptions);
  jqdp.datepicker('refresh');
  _this.configDp(jqdp);

  $dp = $('#ui-datepicker-div');

  // mouseenter and mouseleave for datepicker datecell
  $dp.on('mouseenter', '.ui-datepicker-calendar td[data-handler="selectDay"]', function() {
    var days = _this.c.searchDuration;
    var cell = $(this);
    var elements = cell.nextAll('td:lt('+ days +')'); // find cells to highlight in this row
    elements.find('a, span').addClass('ui-state-hover');
    var searchDuration = _this.c.searchDuration;

    if ($('#search-duration').val() == '8-days') {
      days = 7;
      searchDuration = 7;
    }

    days -= elements.length; // subtract number of days already highlighted

    if (days > 0) {
      cell = cell.parents('tr').next().find('td:first'); // point to the next row

      while (days > 0 && cell) {
        var row = cell.parents('tr');
        elements = row.find('td:lt('+ days +')');
        elements.find('a, span').addClass('ui-state-hover');

        if (elements.length > 0) {
            days -= elements.length;
        } else {
            days = 0;
        }

        // find next row starting cell
        cell = row.next().find('td:first');
      }
    }

    var $firstHoverCell = $dp.find('.ui-datepicker-calendar td .ui-state-hover:eq(0)');
    $firstHoverCell.siblings('i.date-sign-indicator-start').addClass('current');

    // number of cells to highlight = (number of difference days between start and finish) + 1
    var lastHoverCellIndex = searchDuration;

    var $lastHoverCell = $dp.find('.ui-datepicker-calendar td .ui-state-hover:eq(' + (lastHoverCellIndex) + ')');
    $lastHoverCell.siblings('i.date-sign-indicator-end').addClass('current');
  });

  $dp.on('mouseleave', '.ui-datepicker-calendar td[data-handler="selectDay"]', function() {
    $('.ui-state-hover').removeClass('ui-state-hover');
    $dp.find('.ui-datepicker-calendar td > i.date-sign-indicator.current').removeClass('current');
  });

  var topHelperContent = _this.genTopContent();
  var botHelperContent = _this.genBotContent();

  $dateInput.on('focus', function() {
    setTimeout(()=>{

      $dp.find('table.ui-datepicker-calendar').attr('id', 'goa-enhanced')
      
      var topHelperExisted = $dp.children('.goa-dp-helper-top').length != 0;
      if (!topHelperExisted) {
        $dp.prepend(topHelperContent);
      }
      
      var botHelperExisted = $dp.children('.goa-dp-helper-bottom').length != 0;
      if (!botHelperExisted) {
        $dp.append(botHelperContent);
      }
  
      $dateCell = $dp.find('table.ui-datepicker-calendar tr td');
  
      if ($dateCell.find('i').length == 0) {
        $dateCell.append("<i class='date-sign-indicator date-sign-indicator-start'></i'>");
        $dateCell.append("<i class='date-sign-indicator date-sign-indicator-end'></i'>");
      }
    })
  });

  $search = $('#availability-search button');
  $search.on('click', function() {
    var from = $dateInput.attr('data-search-from');
    var to = $dateInput.attr('data-search-to');

    if (!from || !to) {
      $dateInput.focus();
      return;
    };

    from = JSON.parse(from);
    from = new Date(from.year, from.month, from.date);
    from = _this.dfForQuery(from)

    to = JSON.parse(to);
    to = new Date(to.year, to.month, to.date);
    to = _this.dfForQuery(to)

    var url = _this.c.searchUrl + '?start=' + from + '&finish=' + to;
    var tags = '';
    if ($('#search-size').val() !== '') {
      tags += $('#search-size').val();
    }

    var localData = {
      'size': $('#search-size').val(),
      'duration': $('#search-duration').val(),
      'dates': {
        'from': from,
        'to': to
      }
    };

    if (typeof(Storage) !== 'undefined') {
      sessionStorage.setItem('searchData', JSON.stringify( localData ));
    }

    if (tags !== '') {
      url += '&tags=' + tags;
    }
    window.location.href = url;
  });

  $dateInput.prop('disabled', true);

  // apply session data
  if (typeof(Storage) !== 'undefined') {
    if (sessionStorage.getItem('searchData')) {
      $(window).on('load', function(){
        var searchObj = JSON.parse( sessionStorage.getItem('searchData') );
        if (typeof searchObj.size !== 'undefined' && searchObj.size !== '') {
          $anchor.find('#search-size').val( searchObj.size );
        }
        if (typeof searchObj.duration !== 'undefined' && searchObj.duration !== '') {
          $anchor.find('#search-duration').val( searchObj.duration );
        }
        if (typeof searchObj.dates !== 'undefined') {
          var dateFrom = new Date(searchObj.dates.from),
            dateTo = new Date(searchObj.dates.to),
            dateRangeStr = _this.dfForSearchInput(dateFrom) + ' - ' + _this.dfForSearchInput(dateTo);

          $dateInput.val(dateRangeStr);

          $dateInput.attr('data-search-from', JSON.stringify({
            year: dateFrom.getFullYear(),
            month: dateFrom.getMonth(),
            date: dateFrom.getDate()
          }));
          $dateInput.attr('data-search-to', JSON.stringify({
            year: dateTo.getFullYear(),
            month: dateTo.getMonth(),
            date: dateTo.getDate()
          }));
        }
      });
    }
  }

  var today = moment().format('YYYY-MM-DD');
  var next2Years = moment().add(2, 'years').format('YYYY-MM-DD');
  var url = goaSearch.c.apiUrl + '?start='+ today + '&end=' + next2Years + '&products=' + goaSearch.c.dummyProductId;
  $.ajax({
    method: 'GET',
    url: url,
    headers: { 'Authorization': 'Bearer ' + goaSearch.c.apiToken },
    success: function(result) {
      var blackouts = result.blackouts.filter(function(blackout) {
        return blackout.products.length == 0 // Keep blackout that is not bound to any product
      }).map(function(blackout) {
        var boStart = blackout['start'];
        var boEnd = blackout['end'];
        var start = new Date(boStart[0], boStart[1] - 1, boStart[2]);
        start = moment(start).format('YYYY-MM-DD');
        var end = new Date(boEnd[0], boEnd[1] - 1, boEnd[2]);
        end = moment(end).format('YYYY-MM-DD')
        return { start, end }
      });

      $dateInput.datepicker('option', 'beforeShowDay', function(date) {
        var isSunday = (date.getDay() === 0);

        thisDate = moment(date)
        isBlackouted = blackouts.some(function(blackout) {
          return thisDate.isBetween(blackout['start'], blackout['end'], 'days', [])
        })

        isBadDate = isSunday|| isBlackouted

        css = (isBadDate && 'bta-closed') || ''
        tooltip = (isBadDate && (isSunday ? 'Closed' : 'Boutique Closed')) || ''
        return [!isBadDate, css, tooltip]
      });
    },
    complete: function() {
      $dateInput.prop('disabled', false);
    }
  });
};

goaSetupSearchForm.apply(goaSearch);
